import React from 'react';
import PropTypes from 'prop-types';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

import { titleEspecial, urlAssets  } from '../../Constants';

const Image = props => {

    const { name, slug, achievment, type } = props;
    const legend = `${titleEspecial} - ${achievment} - ${name}`;
    
    return (
        <article className="mb-4 text-center">
            <figure>
                <LazyLoadImage
                    alt={achievment}
                    className="img-fluid"
                    effect="blur"
                    src={`${urlAssets}/img/notas/${type}/${slug}.jpg`}
                />
                <figcaption className="d-none">{legend}</figcaption>
            </figure>
        </article>
    )
}

export default Image;

Image.props = {
    name: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    achievment: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,    
}
